module.exports = __webpack_public_path__ + "images/rich_heading/small_appliance/camera/icon_13b08a3db23b909a4f7dc046d5b5a06b.png";